import Vue from "vue";
import Router from "vue-router";
import pc from "@/views/pc/index";
import howHeart from "@/views/pc/howHeart";
import howWork from "@/views/pc/howWork";
import support from "@/views/pc/support";
import mb from "@/views/mobile/index";
import mhowHeart from "@/views/mobile/howHeart";
import mhowWork from "@/views/mobile/howWork";
import msupport from "@/views/mobile/support";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "pc",
      meta:{
        type:"pc",
        url:"/m"
      },
      component: pc
    },
    {
      path: "/howHeart",
      name: "howHeart",
      meta:{
        type:"pc",
        url:"/mhowHeart"
      },
      component: howHeart
    },
    {
      path: "/howWork",
      name: "howWork",
      meta:{
        type:"pc",
        url:"/mhowWork"
      },
      component: howWork
    },
    {
      path: "/support",
      name: "support",
      meta:{
        type:"pc",
        url:"/msupport"
      },
      component: support
    },
    {
      path: "/m",
      name: "mb",
      meta:{
        type:"m",
        url:"/"
      },
      component: mb
    },
    {
      path: "/mhowHeart",
      name: "mhowHeart",
      meta:{
        type:"m",
        url:"/howHeart"
      },
      component: mhowHeart
    },
    {
      path: "/mhowWork",
      name: "mhowWork",
      meta:{
        type:"m",
        url:"/howWork"
      },
      component: mhowWork
    },
    {
      path: "/msupport",
      name: "msupport",
      meta:{
        type:"m",
        url:"/support"
      },
      component: msupport
    }
  ]
});

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js